<template>
    <div class="container">
        <h1>关于我们</h1>
        <p>阿威达通信技术（深圳）有限公司西安分公司成立于2023年11月14日，注册地位于陕西省西安市高新区锦业一路11号国家服务外包示范基地一区E座402，法定代表人为吴小萍。经营范围包括一般项目：通讯设备销售；广播电视传输设备销售；通信设备销售；网络设备销售；电子产品销售；信息技术咨询服务；工程和技术研究和试验发展（除人体干细胞、基因诊断与治疗技术开发和应用，中国稀有和特有的珍贵优良品种）；机械设备研发；通信设备制造；软件开发；软件销售；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；货物进出口；进出口代理。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）</p>
        <button style="margin-bottom: 15px;" class="btn btn_primary" @click="backToPay">返回</button>
    </div>
</template>
<script>
export default {
    name: 'AboutUs',
    data() {
        return {
        }
    },
    methods: {
        backToPay() {
            this.$router.push('/pay')
        },
    },
    mounted() {
    },
    created() {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "index";
</style>


// WEBPACK FOOTER //
// src/components/aboutUs.vue